export default __webpack_public_path__ + "static/media/logo-instagram.15582055.svg";